import React, { FC, memo } from 'react'
import { useTranslate } from 'react-polyglot'
import { Button } from '@getgo/chameleon-web-react-wrapper'
import { Box } from '@material-ui/core'

interface DismissNotificationProps {
  notificationKey: string | number | undefined
  closeSnackbar?: (notificationKey: string | number | undefined) => void
}

const DismissNotification: FC<DismissNotificationProps> = ({ notificationKey, closeSnackbar }) => {
  const t = useTranslate()

  return (
    <Box mr={2} ml={6}>
      <Button
        variant="tertiary"
        onClick={() => {
          if (closeSnackbar) {
            closeSnackbar(notificationKey)
          }
        }}
      >
        {t('Dismiss')}
      </Button>
    </Box>
  )
}

export default memo(DismissNotification)
